import { notFound } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'

import type { MeQueryData } from '@/hooks/use-auth'
import type { ServerFlagKey } from '@/lib/feature-flags'
import { AUTH_ME_QUERY_KEY, meQueryFn } from '@/hooks/use-auth'

const FLAG_FIELD = {
    'server:shop': 'shopEnabled',
    'server:zalo-oa': 'zaloOAEnabled',
} as const satisfies Record<ServerFlagKey, keyof MeQueryData>

/** Giá trị cờ server trong state /auth/me; undefined = chưa biết. */
export function readServerFlag(
    data: MeQueryData | undefined,
    flag: ServerFlagKey,
): boolean | undefined {
    return data?.[FLAG_FIELD[flag]]
}

/**
 * Gác route theo cờ server của bản deploy (/auth/me): tắt → trang không tồn
 * tại, như menu đã ẩn. Ngay sau đăng nhập cache /auth/me chưa có cờ (undefined)
 * → đọc lại một lần thay vì chặn oan.
 *
 * `allowUnknown`: chỉ chặn khi server nói rõ là tắt — cho trang ngoài _authed
 * (chưa đăng nhập thì /auth/me không có cờ nhưng trang vẫn phải hiện).
 */
export async function requireServerFlag(
    client: QueryClient,
    flag: ServerFlagKey,
    opts: { allowUnknown?: boolean } = {},
): Promise<void> {
    const query = { queryKey: AUTH_ME_QUERY_KEY, queryFn: meQueryFn }
    let value = readServerFlag(
        await client.ensureQueryData<MeQueryData>(query),
        flag,
    )
    if (value === undefined) {
        value = readServerFlag(
            await client.fetchQuery<MeQueryData>(query),
            flag,
        )
    }
    if (value === true || (opts.allowUnknown && value === undefined)) return
    throw notFound()
}
